import React from 'react';
const DropdownDown = './assets/icon/dropdown-down.svg';
const COLOR_AVA = {
  width: 24,
  height: 24,
  borderRadius: '50%',
  marginRight: 18,
  marginBottom: 18,
};

const CardTemplate = ({ img, title, alt, listColor, id, togglePrimaryPallet, showPrimaryPallet }) => {
  return (
    <div className="card-template">
      <figure className="card-template__image" style={{ background: listColor.defaultColor[0] }}>
        <img src={img} alt={alt} title={title} />
      </figure>
      <div className="card-template__content">
        <h1>{title}</h1>
        <div className="card-template__content-color-list">
          {listColor.defaultColor.map((_, i) => (
            <div key={i}>
              <div
                className="card-template__content-color-list-color"
                style={{ backgroundColor: _ }}
                onClick={() => togglePrimaryPallet(`${i}${id}`)}
              />
              <div className={`${showPrimaryPallet === `${i}${id}` ? 'show' : 'hide'}-primary-pallet`}>
                <div className="show-primary-pallet__content">
                  <span>Primary</span>
                  <div style={{ marginBottom: 20 }} />
                  {listColor.availableColor.map((_, i) => (
                    <div key={i} className="show-primary-pallet__content-color">
                      <div style={{ ...COLOR_AVA, backgroundColor: _.color }} />
                      <h6>{_.name}</h6>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
          <img
            src={DropdownDown}
            alt={'dropdown-down'}
            className="card-template__content-color-list-package"
            onClick={() => togglePrimaryPallet(`${99}${id}`)}
          />
          <div className={`${showPrimaryPallet === `${99}${id}` ? 'show' : 'hide'}-package-pallet`}>
            <div className="show-package-pallet__content">
              <span>Color Package</span>
              <div style={{ marginBottom: 20 }} />
              <div className="show-package-pallet__content-wrapper">
                {[...Array(20)].map((_, i) => (
                  <div
                    key={i}
                    className="show-package-pallet__content-color"
                    style={{
                      backgroundColor: `rgb(245, 20, 148, 0.${(i + 1) * 2}`,
                    }}
                  ></div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <h5>Live Preview</h5>
      </div>
    </div>
  );
};

export default CardTemplate;
